import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UpdateContainerData {
  name?: string;
  schemaUuid?: string;
  containerUuid: string;
  dynamic?: boolean;
  reindex?: boolean;
}

interface UpdateContainerResponse {
  data: any;
}

export function useUpdateContainer() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      updateData: UpdateContainerData
    ): Promise<UpdateContainerResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/update_container`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(updateData),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userContainers']
      });
    },
  });
}
